import { RiskLevelIndicator } from "./riskLevels/riskLevelIndicators";

// Mirrors the backend RiskAreaAssessmentLevel: what the risks in the area are scored on. An entity row carries
// one assessment per scenario, an organisation row is a single scenario scored once for the organisation.
export enum RiskAreaAssessmentLevel {
    Entity = 1,
    Organisation = 2,
    Both = 3,
}

export interface RiskAreaSaveModel {
    id: string;
    name: string;
    // Null while the user has not picked a responsible; validated as required on save.
    responsibleId: string | null;
    assessmentLevel: RiskAreaAssessmentLevel;
    scale: number;
    // Appetite and matrix cells are null while the user has cleared the field; validated as required on save.
    appetite: number | null;
    consequenceLevels: string[];
    probabilityLevels: string[];
    riskLevels: string[];
    // Chosen indicator per risk level (one entry per scale step).
    riskLevelIndicators: RiskLevelIndicator[];
    matrix: (number | null)[][];
    // Required by the backend once the change re-cuts the measurement instrument; collected in the
    // confirmation step rather than in the form, because it is a justification for a decision, not a setting.
    changeReason?: string | null;
    // The approved per-axis re-base rule, set by the wizard and required by the backend for a scale change.
    // One target level per level of the previous scale.
    scaleMapping?: { consequence: number[]; probability: number[] } | null;
}

// Mirrors the backend RiskAreaConfigChangeKind. Derived client-side to pick the save path, and returned by the
// impact endpoint so the two can never disagree about what a proposed change is.
export enum RiskAreaConfigChangeKind {
    None = 1,
    Cosmetic = 2,
    Semantic = 3,
    Structural = 4,
}

export interface RiskAreaFrameChangeImpact {
    changeKind: RiskAreaConfigChangeKind;
    // Scale by scale on the current frame, indexed [consequence - 1][probability - 1].
    assessmentsPerCell: number[][];
    // Answered for a change that keeps the scale; a scale change answers assessmentsReBased instead.
    assessmentsChangingLevel: number;
    assessmentsReBased: number;
    newlyOverAppetite: number;
    noLongerOverAppetite: number;
    acceptancesNeedingReconfirmation: number;
    openPlansNeedingReconfirmation: number;
}
